import { Store, GetterTree, MutationTree, ActionTree, Module } from "vuex";

import { RootState } from "..";
import { IPortalUser } from "../../models/interfaces/authentication/portal-user.model.interface";
import { IUserManagementState } from "../states/user-management-state";
import { userDataService } from "../../services/user-data.service";
import { userRoleService } from "../../services/user-role.service";
import { IRole } from "../../models/interfaces/authentication/role.model.interface";
import { IUserRoleUpdate } from "../../models/interfaces/authentication/user-role-update.model.interface";

export const state: IUserManagementState = {
    user: null,
    users: [],
    roles: []
};

export const getters: GetterTree<IUserManagementState, RootState> = {
    registeredUsers(state) {
        return state.users.filter((obj) => obj.authorised);
    },
    pendingUsers(state) {
        return state.users.filter((obj) => obj.authorised === false);
    },
    user(state) {
        return state.user;
    },
    roles(state) {
        return state.roles;
    }
};

export const mutations: MutationTree<IUserManagementState> = {
    users(state, users: IPortalUser[]) {
        state.users = users;
    },
    user(state, user: IPortalUser) {
        state.user = user;
    },
    roles(state, roles: IRole[]) {
        state.roles = roles;
    },
    authorise(state) {
        if (state.user) {
            state.user.authorised = true;
        }
    },
    block(state, block: boolean) {
        if (state.user) {
            state.user.blocked = block;
        }
    },
    revenueAccess(state, revenueAccess: boolean) {
        if (state.user) {
            state.user.revenueAccess = revenueAccess;
        }
    }
};

export const actions: ActionTree<IUserManagementState, RootState> = {
    async authorise({ state, commit }, id: number) {
        return new Promise((resolve, reject) => {
            userDataService.authorise(id)
                .then((value) => {
                    commit("authorise");
                    resolve(value);
                });
        });
    },
    async block({ state, commit }, id: number) {
        return new Promise((resolve, reject) => {
            userDataService.block(id, true)
                .then((value) => {
                    if (value) {
                        commit("block", true);
                    }

                    resolve(value);
                });
        });
    },
    async unBlock({ state, commit }, id: number) {
        return new Promise((resolve, reject) => {
            userDataService.block(id, false)
                .then((value) => {
                    if (value) {
                        commit("block", false);
                    }

                    resolve(value);
                });
        });
    },
    async denyRevenueAccess({ state, commit }, id: number) {
        return new Promise((resolve, reject) => {
            userDataService.revenueAccess(id, false)
                .then((value) => {
                    if (value) {
                        commit("revenueAccess", false);
                    }
                    resolve(value);
                });
        });
    },
    async allowRevenueAccess({ state, commit }, id: number) {
        return new Promise((resolve, reject) => {
            userDataService.revenueAccess(id, true)
                .then((value) => {
                    if (value) {
                        commit("revenueAccess", true);
                    }
                    resolve(value);
                });
        });
    },
    async setUser({ state, commit }, id: number) {
        return new Promise((resolve, reject) => {
            userDataService.getUser(id)
                .then((value) => {
                    commit("user", value);
                    resolve();
                });
        });
    },
    async retrieveUsers({ state, commit }) {
        return new Promise((resolve, reject) => {
            userDataService.getUsers()
                .then((value) => {
                    if (value && value.result) {
                        commit("users", value.result);
                        resolve(value.success);
                    }
                    resolve(false);
                });
        });
    },
    async retrieveRoles({ state, commit }) {
        return new Promise((resolve, reject) => {
            userRoleService.getRoles()
                .then((value) => {
                    commit("roles", value.result);
                    resolve();
                });
        });
    },
    async setUserRole({ state, commit }, model: IUserRoleUpdate) {
        return new Promise((resolve, reject) => {
            userRoleService.setUserRole(model.userId, model.roleId)
                .then((value) => {
                    resolve(value);
                });
        });
    }
};

export const userManagementModule: Module<IUserManagementState, RootState> = {
    state, getters, mutations, actions, namespaced: true
};
